export default "__VITE_ASSET__DRIiB32A__"